import { env } from '@/env/env';

export default {
    url: env(process.env.VUE_APP_SOCKET_URL, null),
};
